import React, { useState } from "react";
import { dms } from "./api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Camera } from "lucide-react";

// Shows a small camera icon for a payment that has a proof photo; click opens the photo
export default function ProofButton({ proofId }) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  if (!proofId) return null;

  const show = async () => {
    setOpen(true);
    setLoading(true);
    try {
      const blob = await dms.paymentProofBlob(proofId);
      setUrl(URL.createObjectURL(blob));
    } catch (e) {
      toast.error("Could not load proof photo");
      setOpen(false);
    }
    setLoading(false);
  };
  const onOpenChange = (v) => {
    setOpen(v);
    if (!v && url) { URL.revokeObjectURL(url); setUrl(""); }
  };

  return (
    <>
      <button type="button" onClick={show} title="View payment proof"
        className="inline-flex items-center justify-center h-7 w-7 rounded-md border border-[#eadfb0] bg-[#faf6e6] text-[#8a6600] hover:bg-[#f3e6c2]"
        data-testid="payment-proof-btn">
        <Camera size={14} />
      </button>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>Payment proof</DialogTitle></DialogHeader>
          {loading && <div className="p-6 text-center text-sm text-slate-500">Loading…</div>}
          {url && <img src={url} alt="Payment proof" className="w-full max-h-[70vh] object-contain rounded-lg border border-slate-200" />}
        </DialogContent>
      </Dialog>
    </>
  );
}
